import { ReactNode } from "react";
import {
  AnimatePresence,
  motion,
  useDragControls,
} from "framer-motion";
import "./Drawer.scss";

type Props = {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  children?: ReactNode;
};

const CLOSE_THRESHOLD = 100;

const Drawer: React.FC<Props> = ({ open, onClose, title, children }) => {
  const dragControls = useDragControls();

  const handleDragEnd = (_: unknown, info: { offset: { y: number } }) => {
    if (info.offset.y > CLOSE_THRESHOLD) onClose();
  };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            key="artist-drawer-backdrop"
            className="artist-drawer-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={onClose}
          />
          <motion.div
            key="artist-drawer"
            className="artist-drawer"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 280, damping: 30 }}
            drag="y"
            dragListener={false}
            dragControls={dragControls}
            dragConstraints={{ top: 0, bottom: 0 }}
            dragElastic={{ top: 0, bottom: 0.7 }}
            dragMomentum={false}
            onDragEnd={handleDragEnd}
          >
            <div
              className="handle"
              onPointerDown={(event) => dragControls.start(event)}
            >
              <div className="grip" />
            </div>
            {title && <div className="header">{title}</div>}
            <div className="content">{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Drawer;
